module.exports = __webpack_public_path__ + "img/6.5a5dd55d.jpg";